<template>
  <div class="my-layout-box ">
    <list-view
      :getList="getList"
      :isTabsShow="isTabsShow"
      :isButtonShow="isButtonShow"
      :isSearchShow='isSearchShow'
      :listMap="listMap">
    </list-view>
  </div>
</template>

<script>
import listView from "~/components/List/ListView.vue";
import { itemsData } from "./config";
import { getPaymentOrder } from "~/api/finance";
export default {
  name: "PaymentOrderView",
  components: {
    listView
  },
  data() {
    return {
      isTabsShow: false,
      isButtonShow: false,
      isSearchShow: false,
      listMap: itemsData
    };
  },

  methods: {
    async getList(pagination, searchData) {
      let sendData = {
        page: pagination.page,
        limit: pagination.size
      };
      sendData.value = searchData.value;
      const list = await getPaymentOrder(sendData);
      const data = {
        List: list.Items,
        Total: list.Total
      };
      return data;
    }
  }
};
</script>

<style lang="less" scope></style>
